<template>
  <div class="kanban-board-view">
    <KanbanBoard />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import KanbanBoard from "../components/KanbanBoard.vue";

export default defineComponent({
  name: "KanbanBoardView",
  components: {
    KanbanBoard,
  },
});
</script>

<style scoped>
.kanban-board-view {
  height: 100vh;
  width: 100vw;
  overflow: scroll;
}
</style>
